import React from "react";
import {Row, Col} from "react-bootstrap";
import "./footer.css";

import { pricingURL,
  logoURL, 
  aboutURL, 
  tcURL, 
  ppURL, 
  dsURL,
  gettingStartedURL,
  trailUltraGuidesURL,
  trailUltraRacePlansURL,
  supportURL,
  emailURL,
  fblogoURL,
  instalogoURL,
  twitterlogoURL,
} from "../../services/links";

const Footer = () => {
  return (
    <>
    <div id="contact" className="footer">
      <div className="container">
        <Row>
          <div className= "col-md-2 footer-col">
            <a href="https://www.waldup.com"><img src={logoURL} alt="waldup" style={{width: '110px'}}></img></a>
            </div>
          <Col md="3">
            <div className="footer-col first">
                <h5>The Company</h5>
                <div className="media-body footer-content-1">
                  <a className="white" href={aboutURL}>About us</a>
                </div>
                <div className="media-body footer-content-1">
                  <a className="white" href={tcURL}>Terms & Conditions</a>
                </div>
                <div className="media-body footer-content-1">
                    <a className="white" href={ppURL}>Privacy Policy</a>
                </div>
                <div className="media-body footer-content-1">
                  <a className="white" href={dsURL}>Disclaimer</a>
                </div>
                <div className="media-body footer-content-1">
                  <a className="white" href={aboutURL}>Acknowledgements</a>
                </div>
            </div>
          </Col>
          <Col md="3">
            <div className="footer-col middle">
              <h5>Support</h5>
              <div className="media-body footer-content-1">
                <a className="white" href={gettingStartedURL}>Getting Started</a>
              </div>
              <div className="media-body footer-content-1">
                <a className="white" href={trailUltraGuidesURL}>Runner guides</a>
              </div>
              <div className="media-body footer-content-1">
                <a className="white" href={trailUltraRacePlansURL}>Trail & Ultra running race plans</a>
              </div>
              <div className="media-body footer-content-1">
                <a className="white" href={supportURL}>Product Documentation</a>
              </div>
              <div className="media-body footer-content-1">
                <a className="white" href={pricingURL}>Pricing</a>
              </div>
            </div>
          </Col>
          <Col md="3">
            <div className="footer-col last">
              <h5>Contact</h5>
              <div className="media-body footer-content-1">
              <div className="social-icon">
                  <a href="mailto:team@waldup.com" id="link-to-email">
                  <img src={emailURL} alt="contact"></img>
                  </a>
                </div>
                <div className="social-icon">
                  <a href="https://www.facebook.com/waldupapp/" target="_blank" rel="noreferrer" id="link-to-fb">
                  <img src= {fblogoURL} alt="contact"></img>
                  </a>
                </div>
                <div className="social-icon">
                  <a href="https://twitter.com/waldupapp" target="_blank" rel="noreferrer" id="link-to-twitter">
                  <img src= {instalogoURL} alt="contact"></img>
                  </a>
                </div>
                <div className="social-icon">
                  <a href="https://www.instagram.com/waldupapp/" target="_blank" rel="noreferrer" id="link-to-insta">
                  <img src= {twitterlogoURL} alt="contact"></img>                  
                  </a>
                </div>
              </div>
            </div> 
          </Col> 
        </Row>
      </div>
    </div>
    <div className="copyright">
      <div className="container">
        <Row>
          <Col lg='12'>
            <p className="p-small">Copyright © 2020. All rights reserved</p>
          </Col>
        </Row>
      </div>
    </div>
    </>
  );
};

export default Footer;
